import { Component, OnDestroy, OnInit } from '@angular/core';
import { Siparis } from '../model/siparis';
import { Subscription } from 'rxjs';
import { Talep } from '../model/talep';
import { RestService } from '../providers/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Teklif } from '../model/teklif';
import { Master } from '../model/master';
import { TeklifKalem } from '../model/teklif-kalem';
import { ParaBirimiTutar } from '../teklif/teklif.component';
import { SiparisOlusturRequest } from '../model/siparis-olustur-request';
import { ToastrService } from 'ngx-toastr';
import { Pair } from 'src/model/pair';
import { KalemMiktar } from 'src/model/kalem-miktar';
import { TalepKalem } from 'src/model/talep-kalem';
import { SiparisKalem } from 'src/model/siparis-kalem';
import { MailRequest } from 'src/model/mail-request';

@Component({
  selector: 'app-siparis-olustur',
  templateUrl: './siparis-olustur.component.html',
  styleUrls: ['./siparis-olustur.component.css']
})
export class SiparisOlusturComponent implements OnInit, OnDestroy {
  talepId = '0'; // Talep Id
  talep: Talep = null;
  siparis: Siparis = new Siparis();
  siparisKalemler: SiparisKalem[] = [];
  private subscriptions: Subscription[] = [];
  totalTutarText = '';
  teklifler: Teklif[];

  teklifCariler: TeklifCariIndex[];
  paraBirimleri: Master[] = null;
  siparisNotu = '';

  siparisOlusturDisabled = true;

  constructor(private toastrService: ToastrService,
    private restService: RestService,
    private router: Router,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.talepId = params.id;
        this.getTalepDetails();
        this.getParaBirimleri();
      } else {
        this.router.navigate(['404']);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTalepDetails() {
    this.restService.talepDetaylar(this.talepId).subscribe(res => {
      if (res) {
        this.talep = res;
        this.getTeklifKalemler();
      }
    });
  }

  talepGit() {
    this.router.navigate(['talep'], { queryParams: { id: this.talep.id } });
  }

  getTeklifKalemler() {
    this.restService.talepTeklifler(this.talepId).subscribe(res => {
      this.teklifler = res;
      // console.log(res);

      this.teklifCariler = [];
      let i = 0;
      for (const teklif of this.teklifler) {
        const teklifCari = new TeklifCariIndex(teklif, i++);
        this.teklifCariler.push(teklifCari);
      }
    });
  }

  teklifKalemSec(event: any, y: TeklifKalem, t: TalepKalem, cariId: number) {
    debugger;
    // if (event.target.checked) {
    //   for (const teklif of this.teklifler) {
    //     for (const teklifKalem of teklif.teklifKalemler) {
    //       if (teklifKalem.id !== y.id && teklifKalem.talepKalemId === y.talepKalemId && y.checked) {
    //         teklifKalem.checked = false;
    //       }
    //     }
    //   }
    // }
    let miktar = 0;

    if (y.siparisMiktar === null || y.siparisMiktar === undefined)
      miktar = y.talepKalem.talepEdilen - t.toplamSiparisMiktar;
    else
      miktar = y.siparisMiktar;

    if (event.target.checked) {
      const kalem = new SiparisKalem();

      kalem.teklifKalemId = y.id;
      kalem.miktar = miktar;
      kalem.cariId = cariId;

      this.siparisKalemler.push(kalem);
    }
    else {
      const i = this.siparisKalemler.findIndex(x => x.cariId === cariId && x.teklifKalemId === y.id);
      if (y.checked) {
        this.siparisKalemler[i].miktar = miktar;
      }
      else {
        this.siparisKalemler.splice(i, 1);
      }
    }

    this.toplamTutarHesapla(t.toplamSiparisMiktar);
  }

  private toplamTutarHesapla(toplamSiparisMiktar: number) {
    const array: ParaBirimiTutar[] = [];
    if (this.paraBirimleri) {
      for (const pb of this.paraBirimleri) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }
    const secilenKalemler = [];
    if (this.teklifler != null) {
      for (const teklif of this.teklifler) {
        for (const teklifKalem of teklif.teklifKalemler) {
          if (teklifKalem.checked) {
            secilenKalemler.push(teklifKalem);
          }
        }
      }

      let miktar = 0;
      // let totalMiktar = 0;
      const kalemMiktar: KalemMiktar[] = []
      for (const t of secilenKalemler) {
        const index = array.findIndex(x => x.paraBirimi.id === t.paraBirimiId);
        if (index !== -1) {

          if (t.siparisMiktar === null || t.siparisMiktar === undefined) {
            miktar = t.talepKalem.talepEdilen - toplamSiparisMiktar;
          }
          else
            miktar = t.siparisMiktar;

          t.siparisMiktar = miktar;

          const idx = kalemMiktar.findIndex(x => x.kalemId === t.talepKalem.id);
          if (idx !== -1) {
            kalemMiktar[idx].toplamMiktar += miktar;
          }
          else {
            kalemMiktar.push(new KalemMiktar(t.talepKalem.id, t.talepKalem.talepEdilen - toplamSiparisMiktar, miktar));
          }

          array[index].tutar += t.tutar * miktar;

          for (const item of kalemMiktar) {
            if ((item.talepEdilen) < item.toplamMiktar) {
              this.toastrService.warning('Miktar aşıldı!', 'Uyarı!');
              this.siparisOlusturDisabled = true;
              return;
            }
            else
              this.siparisOlusturDisabled = false;
          }
        }
      }
    }
    const textArray = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArray.push(`${e.tutar.toLocaleString('tr-TR')} ${e.paraBirimi.aciklama}`);
      }
    }
    this.totalTutarText = textArray.join(' + ');
  }

  private getParaBirimleri() {
    const types = [
      Master.ParaBirimi
    ];
    this.restService.getMasterTypes(types).subscribe(res => {
      if (res) {
        this.paraBirimleri = res.ParaBirimi?.map(x => new Master(x));
      }
    });
  }

  save() {
    const secilenKalemler: Pair[] = [];
    if (this.teklifler != null) {
      for (const teklif of this.teklifler) {
        for (const teklifKalem of teklif.teklifKalemler) {
          if (teklifKalem.checked) {
            // console.log(teklifKalem.teklifId)
            secilenKalemler.push(new Pair(teklifKalem.id, teklifKalem.siparisMiktar));
          }
        }
      }
    }
    if (secilenKalemler.length === 0) {
      alert('seçili kalem yok');
      return;
    }
    const request = new SiparisOlusturRequest();
    request.talepId = Number(this.talepId);
    request.teklifKalemIdMiktarList = secilenKalemler;
    request.siparisNotu = this.siparisNotu;
    // request.siparisKalemler = this.siparis.siparisKalemler;

    this.restService.siparisOlustur(request).subscribe(res => {
      if (res) {
        // const mailRequest = new MailRequest();
        // mailRequest.subject = "SİPARİŞ BİLGİLERİ";
        // mailRequest.template = MailRequest.SIPARIS_FORMU;
        // mailRequest.siparisIdler = [];

        // for (let siparis of res) {
        //   mailRequest.siparisIdler.push(siparis.id);
        // }
        // this.restService.mailGonder(mailRequest).subscribe(res2 => {
        // });
        this.router.navigate(['siparis-olusturuldu']);
      }
    });
  }

  // teklifDetay(id: number) {
  //   this.router.navigate(['teklif'], { queryParams: { id: id.toString() } });
  // }
}

export class TeklifCariIndex {
  teklif: Teklif;
  index: number;

  constructor(teklif: Teklif, index: number) {
    this.teklif = teklif;
    this.index = index;
  }
}

